<template>
  <popup ref="popup" :loading="popupLoading" :before-close="close">
    <div slot="body">
      <el-form
        class="dataForm"
        ref="form"
        :disabled="disabled"
        :model="formParameter"
        :inline="true"
        label-width="80px"
      >
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span
              ><el-tag
                type="success"
                effect="dark"
                size="medium"
                style="width: 280px; height: 100%; font-size: 18px"
                ><i class="el-icon-s-management"></i>
                {{ "报销内容：" + formParameter.name }}</el-tag
              ></span
            >
          </div>
          <el-row>
            <el-col :span="12" style="text-align: center">
              <el-radio class="my-radio1" v-model="radio1" label="同意"
                >同意</el-radio
              >
            </el-col>
            <el-col :span="12" style="text-align: center">
              <el-radio class="my-radio2" v-model="radio1" label="驳回"
                >驳回</el-radio
              >
            </el-col>
          </el-row>

          <el-row style="margin-top: 30px">
            <el-col :span="24">
              <el-form-item label="审批意见"
                ><el-input
                  v-model="spyj"
                  autocomplete="off"
                  type="textarea"
                  :rows="5"
                ></el-input
              ></el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="disabled">
            <el-col :span="12">
              <el-form-item label="审批人" prop="sper"
                ><el-input
                  v-model="formParameter.sper"
                  autocomplete="off"
                ></el-input
              ></el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="审批时间" prop="sptm">
                <el-date-picker
                  v-model="formParameter.sptm"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
      </el-form>
    </div>
    <div slot="footer">
      <el-button
        v-if="!disabled"
        type="primary"
        :loading="confirmLoading"
        @click="confirm()"
        >确 定</el-button
      >
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import fileUpload from "@/components/biz/fileUpload/fileUpload.vue";
import imageUpload from "@/components/biz/imageUpload/imageUpload.vue";
import popup from "@/components/popup/dialogPopup.vue";
import api from "@/api/cw/reimburses.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
export default {
  name: "edit",
  components: {
    fileUpload,
    imageUpload,
    popup,
    selectOptionDictionary,
  },
  data() {
    return {
      approveObject: [], //审批对象
      spyj: "", //审批意见
      radio1: "同意",
      aliyunOssValue: "",
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
    };
  },

  methods: {
    //打开弹框
    open(parameter, title, openType, disabled, size) {
      this.parameter = parameter;
      this.disabled = disabled;
      this.$refs.popup.open(title, size);
      this.reimitems = [{ name: "", cost: 0, itemTime: "" }];
      this.formParameter = {};
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.spyj = "";
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        //单选框状态(判断选中是通过还是驳回)
        let isState = 1;
        if (this.radio1 === "同意") {
          isState = 2;
        } else if (this.radio1 === "驳回") {
          isState = 3;
        }
        //在数组最前面追加审批数据
        this.approveObject.unshift({
          state: isState,
          sper: this.formParameter.userName,
          sptm: "",
          spyj: this.spyj,
        });
        console.log(this.approveObject);
        //提交数据
        let obj = {
          id: this.formParameter.id,
          state: isState,
          sper: this.formParameter.userName,
          sptm: "",
          approveObject: JSON.stringify(this.approveObject),
        };
        api.approve(
          obj,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.close();
            this.$parent.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      });
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;

          this.popupLoading = false;
        });
      } else {
        this.popupLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

.my-radio1 {
  color: #067974;
  font-weight: 600;
}
.my-radio2 {
  color: #ff4848;
  font-weight: 600;
}
</style>
